module.exports = __webpack_public_path__ + "img/logo-reduced.6370b56.svg";